/** CDN assets for the Performance Lab IV Lounge page. */
import { getCompressedAssetUrl } from 'lib/config/assetUrls';

export const PL_IV_LOUNGE_PAGE_BASE = 'web_v2/performance-lab/iv-lounge-page';

const IV_LOUNGE_ASSET_CACHE_VERSION = '?v=1';

const ivLoungeImageSrc = (path: string, width: number): string =>
  `${path}${IV_LOUNGE_ASSET_CACHE_VERSION}/w_${width}`;

const IV_LOUNGE_HERO_VIDEO_DESKTOP = `/${PL_IV_LOUNGE_PAGE_BASE}/iv-full.mp4`;
const IV_LOUNGE_HERO_VIDEO_MOBILE = `/${PL_IV_LOUNGE_PAGE_BASE}/iv-min.mp4`;

export const IV_LOUNGE_HERO_VIDEO = {
  desktop: getCompressedAssetUrl(`${IV_LOUNGE_HERO_VIDEO_DESKTOP}/w_1920`),
  mobile: getCompressedAssetUrl(`${IV_LOUNGE_HERO_VIDEO_MOBILE}/w_1080`),
  mobileFallback: getCompressedAssetUrl(`${IV_LOUNGE_HERO_VIDEO_MOBILE}/w_1080`),
};

export const IV_LOUNGE_HERO_POSTER = {
  desktop: ivLoungeImageSrc(`${PL_IV_LOUNGE_PAGE_BASE}/hero.jpg`, 1920),
  mobile: ivLoungeImageSrc(`${PL_IV_LOUNGE_PAGE_BASE}/hero.jpg`, 1080),
};

/** Full-bleed lounge image break between the statement band and the benefits. */
export const IV_LOUNGE_BREAK_PARALLAX_BG = {
  mobile: `${PL_IV_LOUNGE_PAGE_BASE}/lounge.png`,
  desktop: `${PL_IV_LOUNGE_PAGE_BASE}/lounge.png`,
};

/** REVIV partner wordmark logo. */
export const IV_LOUNGE_REVIV_LOGO = `${PL_IV_LOUNGE_PAGE_BASE}/reviv-logo.svg`;

const IV_LOUNGE_PLAN_ICON_FILENAMES: Record<string, string> = {
  'iv-miniboost': 'iv-miniboost.png',
  'iv-hydromax': 'iv-hydromax.png',
  'iv-ultraviv': 'iv-ultraviv.png',
  'iv-10x-health': 'iv-10x-health.png',
  'iv-megaboost': 'iv-megaboost.png',
  'iv-vitaglow': 'iv-vitaglow.png',
  'iv-nad-125': 'iv-nad-125.png',
  'iv-ultraviv-pro': 'iv-ultraviv-pro.png',
  'iv-glutathione': 'iv-glutathione.png',
  'iv-royal-flush': 'iv-royal-flush.png',
  'iv-revive': 'iv-revive.png',
  'pl-im-b-family': 'pl-im-b-family.png',
  'pl-im-vitamin-c': 'pl-im-vitamin-c.png',
  'pl-im-vitamin-d': 'pl-im-vitamin-d.png',
  'pl-im-vitaboost': 'pl-im-vitaboost.png',
  'pl-im-nad': 'pl-im-nad.png',
};

/** Per-plan infusion icons keyed by plan id. */
export const IV_LOUNGE_PLAN_ICONS: Record<string, string> = Object.fromEntries(
  Object.entries(IV_LOUNGE_PLAN_ICON_FILENAMES).map(([planId, filename]) => [
    planId,
    ivLoungeImageSrc(`${PL_IV_LOUNGE_PAGE_BASE}/iv-icons/${filename}`, 400),
  ]),
);

/** Anchor id used by the hero CTA to scroll down to the infusion lineup. */
export const IV_LOUNGE_LINEUP_ANCHOR_ID = 'iv-lounge-lineup';

/** Anchor id used by CTAs to scroll up to the lead / consult form. */
export const IV_LOUNGE_CONSULT_ANCHOR_ID = 'iv-lounge-consult';

/** Section id of the IV/IM plans inside the shared Performance Lab plan data. */
export const IV_LOUNGE_SECTION_ID = 'iv-therapy';
